import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, ModuleFE_Toaster } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_VolatileImport } from '../ModuleFE_VolatileImport.js';
import './Component_PathwayImportSave.scss';
/**
 * "Save to KM" action for a volatile pathway preview, rendered into the `pathway-import-save`
 * slot at the bottom of the pathway editor. Renders nothing on non-volatile pathway tabs.
 *
 * The actual save (import → purge → close tab → hydrate caches → open editor) is orchestrated
 * by `ModuleFE_VolatileImport.commitPathwayImportToKm`, not here: a successful save closes this
 * tab and unmounts this component, so the async work must live in the (lifecycle-free) module.
 */
export class Component_PathwayImportSave extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.saving ??= false;
        return state;
    }
    onSave = async () => {
        const importId = ModuleFE_VolatileImport.getImportIdForPathway(this.props.tabId, this.props.pathwayId);
        if (!importId)
            return;
        this.setState({ saving: true });
        try {
            const result = await ModuleFE_VolatileImport.commitPathwayImportToKm(importId, this.props.tabId);
            if (result.status === 'missing-file')
                ModuleFE_Toaster.toastError('The original CSV is no longer available — please re-import to save.');
        }
        catch (error) {
            ModuleFE_Toaster.toastError(error instanceof Error ? error.message : 'Save failed.');
        }
        finally {
            // On success the tab closes and this component unmounts; guard against setState-on-unmounted.
            if (this.mounted)
                this.setState({ saving: false });
        }
    };
    render() {
        if (!ModuleFE_VolatileImport.getImportIdForPathway(this.props.tabId, this.props.pathwayId))
            return null;
        return _jsx(LL_H_C, { className: 'component-pathway-import-save', children: _jsx(Button, { variant: 'primary', actionInProgress: this.state.saving, onClick: this.onSave, children: "Save to KM" }) });
    }
}
//# sourceMappingURL=Component_PathwayImportSave.js.map